/* Chart conventions for the admin console: one palette, one axis style, one
   tooltip. Graphite is the primary series; hue only where it carries meaning. */
import React from 'react';
import { fmtDay } from './lib';

export const COLORS = {
  ink: '#27272a',      // primary series
  ink2: '#a1a1aa',     // secondary / comparison series
  faint: '#e4e4e7',    // background bars
  accent: '#6366f1',   // a second categorical series
  good: '#16a34a',
  warn: '#d97706',
  bad: '#dc2626',
  grid: '#ececee',
  axis: '#a1a1aa',
};

export const chartMargin = { top: 8, right: 8, left: 0, bottom: 0 };
export const gridProps = { stroke: COLORS.grid, vertical: false };
export const xAxisProps = {
  axisLine: false,
  tickLine: false,
  tick: { fontSize: 11, fill: COLORS.axis },
  tickMargin: 8,
  minTickGap: 16,
};
export const yAxisProps = {
  axisLine: false,
  tickLine: false,
  tick: { fontSize: 11, fill: COLORS.axis },
  width: 40,
  allowDecimals: false,
};
export const cursorFill = { fill: 'rgba(24,24,27,0.04)' };
export const legendProps = { iconType: 'circle', iconSize: 7, wrapperStyle: { fontSize: 11, paddingTop: 8 } };

/* Recharts tooltip content: a date (or label) heading, then one line per series. */
export function ChartTooltip({ active, payload, label, labelFormatter = fmtDay, valueFormatter }) {
  if (!active || !payload?.length) return null;
  return (
    <div className="rounded-lg border border-border bg-card px-3 py-2 text-xs shadow-lg">
      <p className="mb-1 font-medium text-foreground">{labelFormatter ? labelFormatter(label) : label}</p>
      {payload.map((p) => (
        <div key={p.dataKey} className="flex items-center justify-between gap-4">
          <span className="flex items-center gap-1.5 text-muted-foreground">
            <span className="h-2 w-2 rounded-full" style={{ background: p.color || p.fill || p.stroke }} />
            {p.name}
          </span>
          <span className="tabular font-medium text-foreground">
            {valueFormatter ? valueFormatter(p.value, p) : (p.value ?? 0).toLocaleString('en-US')}
          </span>
        </div>
      ))}
    </div>
  );
}
